/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorSignStatsRequest
 */
export interface ValidatorSignStatsRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatorSignStatsRequest
     */
    address: string;
}

export function ValidatorSignStatsRequestFromJSON(json: any): ValidatorSignStatsRequest {
    return ValidatorSignStatsRequestFromJSONTyped(json, false);
}

export function ValidatorSignStatsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorSignStatsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
    };
}

export function ValidatorSignStatsRequestToJSON(value?: ValidatorSignStatsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
    };
}


